/**
 * Bookmarks Feature - Public API
 * Point d'entrée principal pour le module bookmarks
 */

// Components
export { default as BookmarkButton } from "./components/BookmarkButton"
export { default as BookmarksList } from "./components/BookmarksList"
export { default as BookmarksPanel } from "./components/BookmarksPanel"

// Context
export {
    BookmarksProvider,
    useBookmarksContext,
    useIsBookmarked
} from "./context/BookmarksContext"

// Hooks
export { useBookmarkCheck } from "./hooks/useBookmarkCheck"
export { useBookmarks } from "./hooks/useBookmarks"
export { useBookmarkToggle } from "./hooks/useBookmarkToggle"

// API
export {
    BookmarkApiError, bulkCheckBookmarks, checkBookmark, deleteBookmark, getUserBookmarks, toggleBookmark
} from "./api/bookmarks-api"

// Types
export type {
    Bookmark, BookmarkBulkCheckRequest,
    BookmarkBulkCheckResponse, BookmarkCache, BookmarkCheckRequest, BookmarkError, BookmarkMetadata,
    BookmarkToggleRequest,
    BookmarkToggleResponse, BookmarksContextValue, BookmarksListResponse, UseBookmarkCheckResult, UseBookmarkToggleResult, UseBookmarksResult
} from "./types/bookmark.types"

// Utils
export {
    addToCache, clearCache, getCachedBookmarks, getCachedCount, isInCache, mergeCacheWithServer, removeFromCache,
    removeFromCacheById, setCachedBookmarks
} from "./utils/bookmark-storage"

// Helpers
export { clearUserEmailCache, getClientUserEmail } from "./helpers/client-user-email"

